import { Cookies } from 'react-cookie';


const cookies = new Cookies();

const grantPermission = (requestedRole) => {
  // Получаем данные из куки
  const user = cookies.get('user');
  if (!user) return false;

  try {
    // Проверяем, если данные уже являются объектом, то парсинг не нужен
    const parsedUser = typeof user === 'string' ? JSON.parse(user) : user;
    const roles = parsedUser.roles || []; // Извлекаем массив ролей
    // Проверяем, есть ли среди authority запрашиваемая роль
    return roles.some((role) => role.authority === requestedRole);
  } catch (error) {
    console.error('Error parsing user data from cookie:', error);
    return false;
  }
};

export default grantPermission;
